'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _classnames2 = require('classnames');
var _classnames3 = _interopRequireDefault(_classnames2);
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _colorManipulator = require('@material-ui/core/styles/colorManipulator');
var _Collapse = require('@material-ui/core/Collapse');
var _Collapse2 = _interopRequireDefault(_Collapse);
var _IconButton = require('@material-ui/core/IconButton');
var _IconButton2 = _interopRequireDefault(_IconButton);
var _ExpandMore = require('@material-ui/icons/ExpandMore');
var _ExpandMore2 = _interopRequireDefault(_ExpandMore);
var _Done = require('@material-ui/icons/Done');
var _Done2 = _interopRequireDefault(_Done);
var _moment = require('moment');
var _moment2 = _interopRequireDefault(_moment);
var _reactI18next = require('react-i18next');
var _manageWorkshopByNameState = require('./manageWorkshopByNameState');
var _manageWorkshopByNameState2 = _interopRequireDefault(_manageWorkshopByNameState);
var _ScrollableItems = require('../ScrollableItems');
var _ScrollableItems2 = _interopRequireDefault(_ScrollableItems);
var _CategoryBadges = require('../CategoryBadges');
var _CategoryBadges2 = _interopRequireDefault(_CategoryBadges);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var defaultWorkshopAccentColor = '#8677FB';
var styles = {
  root: {
    backgroundColor: '#F5F6FA',
    padding: '16px 0'
  },
  title: {
    color: '#555555',
    fontSize: 32,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 20
  },
  container: {
    color: '#707070',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 970,
    padding: '0 40px',
    boxSizing: 'border-box',
    margin: 'auto'
  },
  card: {
    margin: '12px 0',
    borderRadius: 10,
    width: '100%',
    backgroundColor: 'white',
    padding: 21,
    boxSizing: 'border-box',
    boxShadow: '0px 3px 6px #D5D6DA',
    position: 'relative'
  },
  cardContent: {
    padding: '0 24px 0 56px',
    '&:before': {
      content: "''",
      position: 'absolute',
      width: 4,
      borderRadius: 30,
      backgroundColor: function backgroundColor(_ref) {
        var workshopAccentColor = _ref.otherProperties.workshopAccentColor;
        return workshopAccentColor || defaultWorkshopAccentColor;
      },
      left: 20,
      top: 21,
      bottom: 25
    }
  },
  cardVisibleContent: {
    display: 'flex',
    justifyContent: 'space-between',
    '& button': {
      padding: 8
    }
  },
  name: {
    fontWeight: 'bold',
    fontSize: 18,
    margin: 0,
    textTransform: 'capitalize'
  },
  description: {
    fontSize: 14,
    marginTop: 8,
    '& img': {
      maxWidth: '100%',
      objectFit: 'contain'
    }
  },
  expand: {
    '& svg': {
      color: function color(_ref2) {
        var workshopAccentColor = _ref2.otherProperties.workshopAccentColor;
        return workshopAccentColor || defaultWorkshopAccentColor;
      }
    },
    padding: 0,
    transform: 'rotate(0deg)',
    marginLeft: 'auto'
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  styledTabRoot: {
    padding: '0 8px',
    letterSpacing: '0.36px',
    fontSize: 12,
    textAlign: 'center'
  },
  month: {
    paddingTop: 2,
    fontSize: 14,
    fontWeight: 'bold',
    textTransform: 'capitalize'
  },
  hoursBar: {
    marginTop: 24
  },
  location: {
    fontSize: 12
  },
  dayScrollButton: {
    position: 'absolute',
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      backgroundColor: function backgroundColor(_ref3) {
        var workshopAccentColor = _ref3.otherProperties.workshopAccentColor;
        return workshopAccentColor || defaultWorkshopAccentColor;
      },
      borderRadius: 20,
      color: 'white',
      cursor: 'pointer'
    }
  },
  hourScrollButton: {
    position: 'absolute',
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      color: 'white',
      borderRadius: 20,
      backgroundColor: '#707070',
      cursor: 'pointer'
    }
  },
  hourList: {
    position: 'relative',
    backgroundColor: 'white',
    color: '#707070'
  },
  dayList: {
    position: 'relative',
    boxShadow: '0px 3px 6px #CECECE',
    borderRadius: 10,
    backgroundColor: '#F5F6FA'
  },
  selectedDayItem: {
    color: 'white',
    borderRadius: 10,
    boxShadow: '3px 3px 6px #D5D6DA',
    '& svg': {
      color: function color(_ref4) {
        var workshopAccentColor = _ref4.otherProperties.workshopAccentColor;
        return workshopAccentColor || defaultWorkshopAccentColor;
      }
    }
  },
  hourWrapper: {
    textAlign: 'center'
  },
  hourLabel: {
    fontSize: 14
  },
  doneIcon: {
    position: 'relative',
    '& svg': {
      color: '#F5F6FA',
      backgroundColor: '#F5F6FA',
      borderRadius: 20,
      position: 'absolute',
      top: -2,
      right: -2,
      height: 10,
      width: 10
    }
  }
};
var WorkshopNames = function (_Component) {
  _inherits(WorkshopNames, _Component);
  function WorkshopNames(props) {
    _classCallCheck(this, WorkshopNames);
    var _this = _possibleConstructorReturn(this, (WorkshopNames.__proto__ || Object.getPrototypeOf(WorkshopNames)).call(this, props));
    _this.isExpanded = function (workshop, expanded) {
      return expanded.indexOf(workshop) >= 0;
    };
    _this.onExpandWorkshop = function (workshop) {
      var expandedWorkshops = _this.state.expandedWorkshops;
      var workshopIndex = expandedWorkshops.indexOf(workshop);
      if (workshopIndex < 0) _this.setState({
        expandedWorkshops: [].concat(_toConsumableArray(expandedWorkshops), [workshop])
      });else {
        var newExpandedWorkshops = [].concat(_toConsumableArray(expandedWorkshops));
        newExpandedWorkshops.splice(workshopIndex, 1);
        _this.setState({
          expandedWorkshops: newExpandedWorkshops
        });
      }
    };
    _this.handleChangeDay = function (value) {
      return function (workshopName) {
        var newSelectedDays = _extends({}, _this.state.selectedDays);
        newSelectedDays[workshopName] = value;
        _this.setState({
          selectedDays: newSelectedDays
        });
      };
    };
    _this.state = {
      expandedWorkshops: [],
      selectedDays: {}
    };
    return _this;
  }
  _createClass(WorkshopNames, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var selectedDays = this.props.selectedDays;
      this.setState({
        selectedDays: selectedDays
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.selectedDays !== this.props.selectedDays) {
        this.setState({
          selectedDays: this.props.selectedDays
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var i18n = this.props.i18n;
      var _props = this.props,
        classes = _props.classes,
        workshops = _props.byName,
        sortedNames = _props.sortedNames,
        categories = _props.categories,
        selectedDays = _props.selectedDays,
        currentCategory = _props.currentCategory,
        setCurrentCategory = _props.setCurrentCategory,
        expanded = _props.expanded,
        toggleExpanded = _props.toggleExpanded,
        entities = _props.entities,
        pagination = _props.pagination,
        cssProperties = _props.cssProperties,
        otherProperties = _props.otherProperties,
        t = _props.t;
      var isFetching = pagination.isFetching;
      var workshopAccentColor = otherProperties.workshopAccentColor,
        showCategories = otherProperties.showCategories;
      var event = entities.events[Object.keys(entities.events)[0]];
      return _react2.default.createElement('div', {
        className: classes.root,
        style: cssProperties
      }, _react2.default.createElement('p', {
        className: classes.title
      }, t('workshops.activities')), _react2.default.createElement('div', {
        className: classes.container
      }, isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        size: 50
      }) : !!Object.keys(workshops).length ? sortedNames.map(function (keyName) {
        var workshopsByName = workshops[keyName];
        var selectedDay = workshopsByName && _this2.state.selectedDays[workshopsByName.name];
        var dates = workshopsByName && workshopsByName.dates;
        var dayItems = Object.keys(dates).map(function (dateKey) {
          var date = dates[dateKey];
          return {
            children: _react2.default.createElement('div', null, _react2.default.createElement('div', {
              className: classes.doneIcon
            }, _react2.default.createElement(_Done2.default, null)), _react2.default.createElement('div', {
              className: classes.styledTabRoot
            }, _react2.default.createElement('div', null, date.dayOfWeek), _react2.default.createElement('div', {
              className: classes.month
            }, date.month + ' ' + date.dayOfMonth))),
            itemValue: dateKey
          };
        });
        var hourItems = selectedDay && dates[selectedDay] && dates[selectedDay].hours && dates[selectedDay].hours.map(function (hour) {
          var startHour = hour.startHour,
            endHour = hour.endHour,
            location = hour.location;
          var separator = startHour && endHour ? ' - ' : '';
          var indicator = startHour ? endHour ? '' : t('date.starts_at') + ' ' : t('date.ends_at') + ' ';
          var hourLabel = '' + indicator + (startHour || '') + separator + (endHour || '');
          return {
            children: _react2.default.createElement('div', {
              className: classes.hourWrapper
            }, _react2.default.createElement('div', {
              className: classes.hourLabel
            }, hourLabel), location && _react2.default.createElement('div', {
              className: classes.location
            }, location)),
            itemValue: hourLabel
          };
        });
        return _react2.default.createElement('div', {
          className: classes.card,
          key: workshopsByName.name
        }, _react2.default.createElement('div', {
          className: classes.cardContent
        }, _react2.default.createElement('div', {
          className: classes.cardVisibleContent
        }, _react2.default.createElement('div', {
          className: classes.info
        }, _react2.default.createElement('p', {
          className: classes.name
        }, workshopsByName.name), !!showCategories && _react2.default.createElement(_CategoryBadges2.default, {
          categories: categories,
          workshopCategories: workshopsByName.workshopCategories
        }), !!workshopsByName.description && _react2.default.createElement('div', {
          className: classes.description + ' ql-editor',
          dangerouslySetInnerHTML: {
            __html: workshopsByName.description
          }
        })), _react2.default.createElement('div', null, _react2.default.createElement(_IconButton2.default, {
          disableRipple: true,
          className: (0, _classnames3.default)(classes.expand, _defineProperty({}, classes.expandOpen, _this2.isExpanded(workshopsByName.name, _this2.state.expandedWorkshops))),
          onClick: function onClick() {
            return _this2.onExpandWorkshop(workshopsByName.name);
          }
        }, _react2.default.createElement(_ExpandMore2.default, null)))), _react2.default.createElement(_Collapse2.default, {
          'in': _this2.isExpanded(workshopsByName.name, _this2.state.expandedWorkshops),
          timeout: 'auto',
          unmountOnExit: true
        }, _react2.default.createElement('div', null, _react2.default.createElement(_ScrollableItems2.default, {
          value: selectedDay,
          getSelectedStyle: function getSelectedStyle(isSelected) {
            return {
              backgroundColor: isSelected ? (0, _colorManipulator.lighten)(workshopAccentColor || defaultWorkshopAccentColor, 0.35) : 'inherit'
            };
          },
          extraClasses: {
            scrollButton: classes.dayScrollButton,
            list: classes.dayList,
            selectedItem: classes.selectedDayItem
          },
          items: dayItems,
          onChange: function onChange(value) {
            return _this2.handleChangeDay(value)(workshopsByName.name);
          }
        })), _react2.default.createElement('div', null, _react2.default.createElement(_ScrollableItems2.default, {
          value: false,
          extraClasses: {
            scrollButton: classes.hourScrollButton,
            list: classes.hourList
          },
          items: hourItems
        })))));
      }) : _react2.default.createElement('h3', null, 'No activities :(')));
    }
  }]);
  return WorkshopNames;
}(_react.Component);
exports.default = (0, _manageWorkshopByNameState2.default)()((0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(WorkshopNames)));